const Noodl = require('@noodl/noodl-sdk');
const { CustomTextInput } = require('@prodikt/ui');

module.exports = Noodl.defineReactNode({
	name: 'Prodikt Custom Text Input',
	category: 'Prodikt',
	getReactComponent() {
		return CustomTextInput;
	},
	inputProps: {
		// Basic properties
		label: {
			type: 'string',
			displayName: 'Label',
			group: 'General'
		},
		placeholder: {
			type: 'string',
			displayName: 'Placeholder',
			group: 'General'
		},
		value: {
			type: 'string',
			displayName: 'Value',
			default: '',
			group: 'Data',
			index: 1000
		},
		type: {
			type: {
				name: 'enum',
				enums: [
					{ label: 'Text', value: 'text' },
					{ label: 'Email', value: 'email' },
					{ label: 'Password', value: 'password' },
					{ label: 'Number', value: 'number' },
					{ label: 'Tel', value: 'tel' },
					{ label: 'URL', value: 'url' }
				]
			},
			displayName: 'Type',
			default: 'text',
			group: 'General'
		},
		disabled: {
			type: 'boolean',
			displayName: 'Disabled',
			default: false,
			group: 'General'
		},
		required: {
			type: 'boolean',
			displayName: 'Required',
			default: false,
			group: 'General'
		},
		fullWidth: {
			type: 'boolean',
			displayName: 'Full Width',
			default: false,
			group: 'Layout'
		},
		size: {
			type: {
				name: 'enum',
				enums: [
					{ label: 'Small', value: 'small' },
					{ label: 'Medium', value: 'medium' },
					{ label: 'Large', value: 'large' }
				]
			},
			displayName: 'Size',
			default: 'medium',
			group: 'Layout'
		},

		// Features
		clearable: {
			type: 'boolean',
			displayName: 'Clearable',
			default: false,
			group: 'Features'
		},
		maxLength: {
			type: 'number',
			displayName: 'Max Length',
			group: 'Features'
		},
		showCharCount: {
			type: 'boolean',
			displayName: 'Show Character Count',
			default: false,
			group: 'Features'
		},

		// Prefix/Suffix
		prefix: {
			type: 'string',
			displayName: 'Prefix',
			group: 'Decorators'
		},
		suffix: {
			type: 'string',
			displayName: 'Suffix',
			group: 'Decorators'
		},

		// Messages
		error: {
			type: 'string',
			displayName: 'Error Message',
			group: 'Messages'
		},
		helperText: {
			type: 'string',
			displayName: 'Helper Text',
			group: 'Messages'
		},

		// Styling
		className: {
			type: 'string',
			displayName: 'CSS Class',
			group: 'Style'
		},
		borderColor: {
			type: 'string',
			displayName: 'Border Color',
			group: 'Style'
		}
	},
	outputProps: {
		onChange: {
			type: 'signal',
			displayName: 'Changed'
		},
		onClear: {
			type: 'signal',
			displayName: 'Cleared'
		},
		currentValue: {
			type: 'string',
			displayName: 'Current Value'
		}
	},
	changed: {
		value: function(value) {
			// Sync output value when input changes
			this._outputValue = value || '';
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = value || '';
			}
			this.flagOutputDirty('currentValue');
		}
	},
	setup: function(context, graphModel) {
		// Handle style objects
		if (!context.propsInput) context.propsInput = {};
	},
	initialize: function() {
		// Initialize output value from props (will be empty initially if connected)
		const initialValue = this.props.value || '';

		// Initialize output value
		this._outputValue = initialValue;
		this._lastPropsValue = initialValue;

		// Store in outputPropValues
		if (!this.outputPropValues) this.outputPropValues = {};
		this.outputPropValues.currentValue = this._outputValue;

		// Flag output as dirty so initial value is sent
		this.flagOutputDirty('currentValue');

		// Poll for value changes from connected inputs
		this._valueCheckInterval = setInterval(() => {
			const currentPropsValue = this.props.value || '';
			if (currentPropsValue !== this._lastPropsValue) {
				this._lastPropsValue = currentPropsValue;
				this._outputValue = currentPropsValue;
				if (this.outputPropValues) {
					this.outputPropValues.currentValue = currentPropsValue;
				}
				this.flagOutputDirty('currentValue');
			}
		}, 50);

		// Set up onChange handler
		this.props.onChange = (value) => {
			// Store output value in multiple places
			this._outputValue = value;
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = value;
			}
			// Update input value
			this.setInputValue('value', value);
			// Flag output as dirty
			this.flagOutputDirty('currentValue');
			// Send the change signal
			this.sendSignalOnOutput('onChange');
		};

		// Set up onClear handler
		this.props.onClear = () => {
			this._outputValue = '';
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = '';
			}
			this.setInputValue('value', '');
			this.flagOutputDirty('currentValue');
			this.sendSignalOnOutput('onClear');
		};
	},
	onNodeDeleted: function() {
		// Clean up interval when node is deleted
		if (this._valueCheckInterval) {
			clearInterval(this._valueCheckInterval);
		}
	},
	update: function() {
		// Sync output if props.value has changed (handles initial connected values)
		const currentValue = this.props.value !== undefined ? this.props.value : '';
		if (this._outputValue !== currentValue) {
			this._outputValue = currentValue;
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = currentValue;
			}
			this.flagOutputDirty('currentValue');
		}
	},
	methods: {
		setValue: function(value) {
			this.setInputValue('value', value);
		},
		getValue: function() {
			return this.props.value || '';
		},
		clearValue: function() {
			this.setInputValue('value', '');
		},
		focus: function() {
			// This would need to be implemented via ref in the component
		}
	}
});
